import api from "../../utils/api";
import { AD_TYPE } from "../../components/advertisement/adTypes";

export const state = {
  _ad: null, // 백엔드 원본 광고 타입
  _resolvedAdType: null, // 실제 FE 노출 타입(miso fallback은 권원보험으로 대체)
  _encryptedCartSeq: null, // house_loan 클릭 시 필요한 encrypted_cart_seq
  _loaded: false,
  _hideAds: false, // 제휴 앱(가스앱 등)에서 외부 배너광고 숨김
};

export const getters = {
  adType: state => state._ad,
  resolvedAdType: state => state._resolvedAdType,
  encryptedCartSeq: state => state._encryptedCartSeq,
  isLoaded: state => state._loaded,
  hideAds: state => state._hideAds,
};

export const mutations = {
  setAdvertisement(state, data) {
    state._ad = data?.ad;
    state._encryptedCartSeq = data?.payload?.encrypted_cart_seq || null;

    // 미소 제휴 종료(2026-07): 백엔드의 기존 miso fallback 자리를 안심 매매 패키지로 대체한다.
    // 원본 _ad는 배너 우선순위 호환을 위해 보존하고 팝업용 resolved 타입만 변환한다.
    if (data?.ad === AD_TYPE.MISO) {
      state._resolvedAdType = AD_TYPE.FIRSTAM;
    } else {
      state._resolvedAdType = data?.ad;
    }
    state._loaded = true;
  },
  setAdLoaded(state, value) {
    state._loaded = value;
  },
  setHideAds(state, value) {
    state._hideAds = value;
  },
};

export const actions = {
  async acFetchAdvertisement({ commit }) {
    try {
      // 제휴 앱(가스앱 등) 진입 시 외부 배너광고 숨김
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get("utm_source") === "gasapp") {
        sessionStorage.setItem("hide_partner_ads", "true");
      }
      if (sessionStorage.getItem("hide_partner_ads")) {
        commit("setHideAds", true);
        return null;
      }

      const res = await api.get("/api/v1/advertisement");
      if (res?.data?.code === 0 && res?.data?.data) {
        commit("setAdvertisement", res.data.data);
        return res.data.data;
      }
      return null;
    } catch (error) {
      console.log("acFetchAdvertisement error:", error.message);
      return null;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
